// import { useWebSocket } from '@nile/home/src/hooks';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import React from 'react';
import AssetTerminal from '@nile/rmm/src/modules/asset-management/components/pages/asset-details-toolbar/Terminal/asset-remote-terminal';

class AssetTerminalPage extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    const { flags } = this.props;
    return <AssetTerminal />;
  }
}

export default withLDConsumer()(AssetTerminalPage);
